<template>
  <el-popover trigger="click" @show="show" @hide="show" width="920px">
    <el-tabs v-model="state.active">
      <el-tab-pane
        v-for="item in $props.list"
        :name="item.alphabet"
        :label="item.alphabet"
        :key="item.alphabet"
      >
        <div class="country-list">
          <div
            class="country-item"
            v-for="it in item.countryList"
            :key="it.countryCode"
            @click="onClick(it)"
          >
            <img
              @error="onError(it.countryCode)"
              :src="
                require(`/public/flags/${it.countryCode.toLowerCase()}.png`)
              "
            />
            <div>
              {{ it.countryNameEn }}
              <br />
              {{ it.countryNameCn }}
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <template #reference>
      <div class="suffix" :class="{ open: state.open }">
        <template v-if="!$props.country">
          <el-icon class="arrow"><ArrowDown /></el-icon>
        </template>

        <el-icon class="close" v-else @click.stop="clearCountry"
          ><CloseBold
        /></el-icon>
      </div>
    </template>
  </el-popover>
</template>

<script setup>
import { defineProps, reactive, defineEmits } from "vue";

const $emit = defineEmits(["change"]);
const $props = defineProps({
  list: {
    type: Array,
    default: () => [],
  },
  country: {
    type: String,
    default: undefined,
  },
});

const state = reactive({
  open: false,
  active: "",
  isInit: false,
});
const show = () => {
  state.open = !state.open;
  state.active = $props.list[0].alphabet;
};

const clearCountry = () => {
  $emit("change", undefined);
};
const onClick = (item) => {
  $emit("change", item.countryCode);
  state.open = false;
};
</script>

<style lang="scss" scoped>
.country-list {
  display: flex;
  // justify-content: ;
  flex-wrap: wrap;
  max-height: 400px;
  overflow-x: auto;
  .country-item {
    width: 25%;
    height: 60px;
    margin: 5px 0;
    img {
      width: 30px;
      // height: auto;

      float: left;
    }
    div {
      margin-left: 40px;
      // display: inline-block;
      font-size: 13px;
      color: #333;
      cursor: pointer;
      &:hover {
        color: #11ba66;
      }
    }
  }
}
.suffix {
  transition: 0.3s;
  padding-left: 10px;
  height: 40px;
  display: flex;
  align-items: center;

  .arrow {
    cursor: pointer;
    &.open {
      transform: rotateX(180deg);
    }
  }
  .close {
    cursor: pointer;
  }
}
</style>
